import type { ActiveKey, Inspection } from '@/db/types'

export function normalizeSearchText(value: string): string {
  return value
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .trim()
    .toLocaleLowerCase('pt-BR')
    .replace(/\s+/g, ' ')
}

export function normalizePhone(value: string): string {
  return value.replace(/\D/g, '')
}

export function toActiveKey(active: boolean): ActiveKey {
  return active ? 1 : 0
}

export function inspectionSearchFields(
  inspection: Pick<Inspection, 'clientSnapshot' | 'machineSnapshot' | 'technicianSnapshot'>,
) {
  return {
    normalizedClientName: normalizeSearchText(inspection.clientSnapshot.companyName),
    normalizedClientPhone: normalizePhone(inspection.clientSnapshot.phone),
    normalizedFarmOrSite: normalizeSearchText(inspection.clientSnapshot.farmOrSite),
    normalizedMachineEquipment: normalizeSearchText(inspection.machineSnapshot.equipment),
    normalizedMachineBrand: normalizeSearchText(inspection.machineSnapshot.brand),
    normalizedMachineModel: normalizeSearchText(inspection.machineSnapshot.model),
    normalizedSerialChassis: normalizeSearchText(inspection.machineSnapshot.serialChassis),
    normalizedTechnicianName: normalizeSearchText(inspection.technicianSnapshot.name),
  }
}
